<template>
  <router-link to="/" class="site-logo" aria-label="叮通科技 首页">
    <span class="logo-mark" aria-hidden="true">
      <img style="border-radius: 10%;" src="@/assets/logo.png" alt="叮通科技 Logo" />
    </span>
    <span class="logo-text" :class="{ dark }">
      <strong>叮通科技</strong>
      <em>DINGTONG · TECH</em>
    </span>
  </router-link>
</template>

<script>
export default {
  name: "SiteLogo",
  props: {
    dark: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.site-logo {
  display: inline-flex;
  align-items: center;
  gap: 11px;
}

.logo-mark {
  display: inline-flex;
  width: 42px;
  height: 42px;
  flex: none;
}

.logo-mark svg {
  width: 100%;
  height: 100%;
}

.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.logo-text strong {
  font-size: 21px;
  letter-spacing: 0.08em;
  color: var(--c-navy);
}

.logo-text em {
  font-style: normal;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.26em;
  color: var(--c-muted);
  margin-top: 3px;
}

.logo-text.dark strong {
  color: #fff;
}

.logo-text.dark em {
  color: rgba(255, 255, 255, 0.55);
}
</style>
